module.exports = __webpack_public_path__ + "static/media/userIcon.fce6a428.svg";